import { upgradeContractRequest } from './upgradeContractRequest';

export const sellerDashboard = {
  upgradeContractRequest,
};
